var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export const AccessButton = styled.a.withConfig({
  displayName: "AccessButton",
  componentId: "sc-1qulioq-0"
})(["display:inline-block;align-items:center;flex-shrink:0;padding:", ";border-radius:", ";margin-left:9px;", ";font-weight:600;", " line-height:36px;color:#fff;text-align:center;&:hover{", ";}", ";", ""], _ref => {
  let {
    small
  } = _ref;
  return small ? '0 12px' : '3px 12px';
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.borderRadius;
}, getFont(0), fontSmoothing, _ref3 => {
  let {
    theme,
    withBackground
  } = _ref3;
  return !withBackground ? "color:".concat(theme.colors.primaryLL) : '';
}, maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), _ref4 => {
  let {
    $hideMobile
  } = _ref4;
  return $hideMobile ? "display: none" : null;
}), _ref5 => {
  let {
    withBackground = true
  } = _ref5;
  return withBackground && css(["border-radius:", ";background-color:", ";&:hover{background-color:#fff;color:", ";}"], _ref6 => {
    let {
      theme
    } = _ref6;
    return theme.borderRadius;
  }, _ref7 => {
    let {
      theme,
      isRegister
    } = _ref7;
    return !isRegister ? 'rgba(255,255,255,0.1);' : theme.secondaryColor;
  }, _ref8 => {
    let {
      theme,
      isRegister
    } = _ref8;
    return !isRegister ? theme.mainColor : theme.secondaryColor;
  });
});